import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';
import { VIDEOS_PATH } from '../../utils/video';

function SiteHeader({ onToggleSearch, onOpenMenu, isSearchOpen, isMenuOpen }) {
    const location = useLocation();
    const { isDarkMode, toggleTheme } = useTheme();

    const isHome = location.pathname === '/' || location.pathname.startsWith('/page/');
    const isAbout = location.pathname.startsWith('/about');
    const isVideos = location.pathname === VIDEOS_PATH || location.pathname.startsWith(`${VIDEOS_PATH}/`);

    return (
        <header className="site-header" role="banner">
            <div className="header-inner">
                <div className="site-branding">
                    <Link className="site-title" to="/" rel="home">The Discerner</Link>
                    <span className="site-tagline">Laymen on Agathology &amp; Ponerology</span>
                </div>
                <div className="header-actions">
                    <nav className="header-nav" aria-label="Primary navigation">
                        <Link
                            className={`header-nav-btn${isHome ? ' active' : ''}`}
                            to="/"
                        >
                            Home
                        </Link>
                        <Link
                            className={`header-nav-btn${isAbout ? ' active' : ''}`}
                            to="/about"
                        >
                            About
                        </Link>
                        <Link className="header-nav-btn" to="/old?portal=1">
                            Author Portal
                        </Link>
                    </nav>
                    {/* Outside .header-nav (hidden on narrow screens) so the
                        videos page stays one tap away at every width. */}
                    <Link
                        className={`header-video-btn${isVideos ? ' active' : ''}`}
                        to={VIDEOS_PATH}
                        aria-label="Video — Condoned Media"
                        aria-current={isVideos ? 'page' : undefined}
                    >
                        <span className="header-video-btn__glyph" aria-hidden="true">▶</span>
                        Video
                    </Link>
                    <button
                        type="button"
                        className="search-toggle"
                        id="search-toggle-btn"
                        aria-label="Open search"
                        aria-expanded={isSearchOpen ? 'true' : 'false'}
                        onClick={onToggleSearch}
                    >
                        Search
                    </button>
                    <button
                        type="button"
                        className="mobile-menu-toggle"
                        id="mobile-menu-btn"
                        aria-label="Open menu"
                        aria-expanded={isMenuOpen ? 'true' : 'false'}
                        aria-controls="mobile-nav"
                        onClick={onOpenMenu}
                    >
                        Menu
                    </button>
                    <button
                        type="button"
                        className="ds-theme-toggle"
                        onClick={toggleTheme}
                        aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
                        title={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
                    >
                        {isDarkMode ? '◐' : '◑'}
                    </button>
                </div>
            </div>
        </header>
    );
}

export default SiteHeader;
